module.exports = __webpack_public_path__ + "media/images/client/favicons/android-chrome-48x48-c065186f264c05deba4ba0688d83d12c.png";